<script>
export default {
  // props: ['primary', 'secondary', 'dark'],
  props: {
    alert: Boolean,
    warning: Boolean,
    primary: Boolean,
    success: Boolean,
    secondary: Boolean,
    ghost: Boolean,
    dark: Boolean,
    bordered: Boolean,
    outline: Boolean,
    none: Boolean,
    underlined: Boolean,
    fitContent: Boolean,
    small: Boolean,
    sm: Boolean,
    text: Boolean,
    minWidth: {
      type: String,
      default: '120px',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: Boolean,
    contentClass: {
      type: String,
      default: 'd-flex align-items-center justify-content-center',
    },
  },
  computed: {
    customClass() {
      if (this.none) {
        return ''
      }
      let classe = 'btn btn'

      // Variantes (sufixo do tipo "btn-<x>") na ordem de aplicação.
      const variants = [
        ['outline', '-outline'],
        ['primary', '-primary'],
        ['success', '-success'],
        ['secondary', '-secondary'],
        ['ghost', '-ghost'],
        ['dark', '-dark'],
        ['bordered', '-bordered'],
        ['underlined', '-underlined'],
        ['alert', '-alert'],
        ['warning', '-warning'],
      ]
      for (const [prop, suffix] of variants) {
        if (this[prop]) classe += suffix
      }

      // Modificadores (classes extras separadas por espaço).
      const modifiers = [
        ['text', ' btn-text'],
        ['small', ' btn-md'],
        ['sm', ' btn-sm'],
        ['fitContent', ' btn-fit-content'],
        ['disabled', ' disabled'],
      ]
      for (const [prop, cls] of modifiers) {
        if (this[prop]) classe += cls
      }

      return classe
    },
  },
}
</script>

<template>
  <button
    type="button"
    :class="customClass"
    :disabled="loading || disabled"
    style="position: relative; font-family: GeneralSans; font-weight: 600"
    :style="{
      minWidth,
    }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      v-if="loading"
      style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
      "
    >
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </div>

    <div
      :class="[contentClass, { 'opacity-0': loading }]"
      style="gap: 8px; min-width: fit-content"
    >
      <slot />
    </div>
  </button>
</template>
